import apiClient from "./apiClient";

export function getDashboardStatsRequest() {
  return apiClient.get("/dashboard/stats");
}
